import OnHandItemTab from "../../../on-hand/components/item/OnHandItemTab";

export default function OnHandFoodItemTab(item, index) {
    const isSelected = (onHandState, name) => {
        let result = false;

        if (onHandState?.restaurant?.group?.item?.ingredient?.data?.name === name) {
            result = true;
        }

        if (onHandState?.restaurant?.group?.item?.ingredient?.data?.alias === name) {
            result = true;
        }

        return result;
    };

    return (
        <OnHandItemTab
            key={`on-hand-item-tab-${index}`}
            dirty={item.inventory.dirty}
            status={item.status}
            name={item.ingredient.data.onHandAlias || item.ingredient.data.name}
            index={index}
            isSelected={isSelected}
        />
    );
}
